<template>
    <div class="voc-attachment-image-upload__container">
        <div
            v-pendo-tooltip="{
                arrow: true,
                content: 'Add or drag an image (JPG, JPEG or PNG, max size 10MB, max images 10)',
            }"
            class="tooltip-container">
            <pendo-button
                label="Add images"
                theme="app"
                type="subtle"
                icon="image"
                size="mini"
                data-cy="voc-feedback-form-upload-attachment"
                @click="handleUpload" />
        </div>
        <input
            ref="imagePopup"
            class="input--hidden"
            multiple="true"
            type="file"
            accept="image/png, image/jpeg"
            data-cy="voc-feedback-form-uploader"
            @change="uploadImage($event.target)">
    </div>
</template>
<script>
import { PendoButton, PendoTooltip } from '@pendo/components';
import { mapActions, mapState } from 'vuex';
import { v4 as uuid } from 'uuid';

export default {
    name: 'VocItemUploadAttachment',
    components: {
        PendoButton,
    },
    directives: {
        PendoTooltip,
    },
    inject: ['vocItem'],
    props: {
        dragAndDroppedFiles: {
            type: Array,
            default: () => [],
        },
        blade: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['validateError'],
    computed: {
        ...mapState({
            localAttachmentList: (state) => state.vocItems.attachmentList,
        }),
    },
    watch: {
        dragAndDroppedFiles: {
            async handler () {
                if (this.dragAndDroppedFiles?.length) {
                    this.uploadImage({
                        files: this.dragAndDroppedFiles,
                    });
                }
            },
            immediate: true,
        },
    },
    methods: {
        ...mapActions({
            addToAttachmentList: 'vocItems/addToAttachmentList',
        }),
        handleUpload () {
            this.$refs.imagePopup.click();
        },
        uploadImage ({ files }) {
            if (files.length === 0) return;
            const errors = [];
            const overLimitErrors = [];

            Array.from(files).forEach((file) => {
                const imageArray = this.localAttachmentList.filter(
                    (attachment) => attachment.type === 'image' || attachment.type === 'loading',
                );
                if (imageArray.length < 10) {
                    const error = this.fileValidateAndStore(file);
                    if (error) errors.push(error);
                } else {
                    overLimitErrors.push(file.name);
                }
            });
            if (overLimitErrors.length > 1) {
                errors.push(
                    `Max 10 image files allowed so could not upload the following files:<br>&nbsp;&nbsp;&nbsp;&nbsp;&bull; <strong>${overLimitErrors.join(
                        '<br>&nbsp;&nbsp;&nbsp;&nbsp;&bull; ',
                    )}</strong>`,
                );
            }
            if (overLimitErrors.length === 1) {
                errors.push(`Max 10 image files allowed so could not upload <strong>'${overLimitErrors[0]}'</strong>.`);
            }
            if (errors.length) this.$emit('validateError', errors.join('<br><br>'));
            if (this.$refs?.imagePopup) this.$refs.imagePopup.value = '';
        },
        fileValidateAndStore (imageFile) {
            if (imageFile.size > 10000000) {
                return `<strong>${imageFile.name}</strong> is too large, please upload a file smaller than 10MB`;
            }
            if (!imageFile.type.match(/image\/(jpeg|png)/i)) {
                return `<strong>${imageFile.name}</strong> is an invalid file type, please upload either a JPEG, JPG, or a PNG file`;
            }
            this.addToAttachmentList({
                attachmentFile: imageFile,
                type: 'image',
                id: uuid(),
                vocItem: this.vocItem,
                persist: this.blade,
            }).catch(() => {
                this.$emit('validateError', `Could not upload ${imageFile.name}, please try again.`);
            });
        },
    },
};
</script>

<style scoped lang="less">
.input--hidden {
    display: none;
}
.tooltip-container {
    display: block;
    width: fit-content;
    height: fit-content;
}
</style>
